export default {
    isNotEmptyArray: function (el) {
        return Array.isArray(el) && el.length > 0;
    },
    isNotEmptyObject: function (obj) {
        return !(Object.entries(obj).length === 0 && obj.constructor === Object);
    },
    isNotUndefined: function (value) {
        return typeof value !== "undefined";
    },
    deleteObjectKeys: function (article, keysAllowed) {
        return Object.keys(article)
            .filter(key => !keysAllowed.includes(key))
            .reduce((obj, key) => {
                obj[key] = article[key];
                return obj;
            }, {});
    },
    extractObjectKeys: function (object, keysAllowed) {
        return Object.keys(object)
            .filter(key => keysAllowed.includes(key))
            .reduce((obj, key) => {
                obj[key] = object[key];
                return obj;
            }, {});
    },
    sortArrayByString: function (array, string) {
      return array.sort(function(a, b) {
        var nameA = a[string].toUpperCase();
        var nameB = b[string].toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        // names must be equal
        return 0;
      });
    },
    filterByIds: function (array, ids, key = 'id') {
      return array.filter(item => {
        return !ids.includes(item[key]);
      });
    },
    arrayIntersection(arr1, arr2) {
      const set1 = new Set(arr1.length < arr2.length ? arr1 : arr2);
      const arrToCheck = arr1.length < arr2.length ? arr2 : arr1;
      // Find intersection by checking each element of the larger array
      return arrToCheck.filter(item => set1.has(item));
    }
}
